module.exports = __webpack_public_path__ + "img/upload.c677c746.svg";